<template>
  <div class="page-wrap" v-loading="loading">
    <el-row>
      <el-col :xs="24" :sm="20" :lg="12" :xl="14">
        <el-form
            ref="formRef"
            :model="form"
            :rules="rules"
            label-position="top"
            hide-required-asterisk
        >
          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="!resultId && isAdmin">
              <el-form-item label="Viloyat" prop="region_id">
                <el-select v-model="form.region_id" style="width: 100%" @change="onChangeRegion">
                  <el-option v-for="region in regions" :key="region.id" :value="region.id" :label="region.title"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="!resultId && isAdmin">
              <el-form-item label="Tuman" prop="district_id">
                <el-select v-model="form.district_id" style="width: 100%">
                  <el-option v-for="district in districts" :key="district.id" :value="district.id"
                             :label="district.title"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12" v-if="!resultId">
              <el-form-item label="Tashabbus doskasi" prop="board_id">
                <el-select v-model="form.board_id" style="width: 100%" >
                  <el-option v-for="board in boards" :key="board.id" :value="board.id"
                             :label="board.title"/>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="12">
              <el-form-item label="Fayl" prop="file_uid">
                <el-upload
                    style="width: 100%"
                    v-model:file-list="resultFileList"
                    :action="fileUploadUrl"
                    :headers="fileUploadHeader"
                    :multiple="false"
                    :limit="1"
                    :on-success="onSuccessFileUpload"
                    :on-remove="handleRemoveFile"
                >
                  <el-button type="primary" :disabled="resultFileList.length>0">Fayl yuklang</el-button>
                </el-upload>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item>
                <el-button class="custom-btn" @click="()=>$router.go(-1)">Orqaga</el-button>
                <el-button class="custom-btn" type="primary" @click="onSubmit">Saqlash</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import {ElNotification} from "element-plus";

export default {
  name: "InitiativeForm",
  data() {

    return {
      fileUploadUrl: `${process.env.VUE_APP_BASE_API_URL}api/v2/info/file/upload`,
      fileUploadHeader: {"Authorization": `${this.$store.state.accessToken}`},
      isAdmin: false,
      loading: false,
      resultId: null,
      form: {
        board_id: null,
        region_id: null,
        district_id: null,
        file_uid: null
      },
      resultFileList: [],
      districts: [],
      regions: [],
      boards: [],
      rules: {
        board_id: [
          {required: true, message: "Majburiy maydon", trigger: 'change'}
        ],
        region_id: [
          {required: true, message: "Majburiy maydon", trigger: 'change'}
        ],
        district_id: [
          {required: true, message: "Majburiy maydon", trigger: 'change'}
        ],
        file_uid: [
          {required: true, message: "Majburiy maydon", trigger: 'change'}
        ],
      },
    }
  },
  methods: {
    handleRemoveFile() {
      this.form.file_uid = null;
    },
    onSuccessFileUpload(res) {
      this.form.file_uid = res.hashId
    },
    onSubmit() {
      this.$refs.formRef.validate(valid => {
        if (valid) {
          this.loading = true;

          let http;

          if (this.resultId) {
            http = this.$http.patch(`api/v1/moderation-results/${this.resultId}`, {file_uid: this.form.file_uid})
          } else {
            http = this.$http.post(`api/v1/moderation-results`, this.form)
          }

          http.then(() => {
            ElNotification({
              title: 'Tabriklaymiz',
              message: 'Muvafaqiyatli saqlandi',
              type: 'success',
            })
            this.$router.go(-1)
          }).catch(({response}) => {
            ElNotification({
              title: 'Xatolik',
              message: response.data.message,
              type: 'error',
            })
          }).finally(() => {
            this.loading = false
          })
        }
      })
    },
    onChangeRegion() {
      this.districts = []
      this.getDistricts()
    },
    getRegions() {
      this.$http.get(`api/v1/regions`).then(({data}) => {
        this.regions = data.regions
      }).catch((err) => {
        console.error('quarters fetch error', err)
      })
    },
    getDistricts() {
      this.$http.get(`api/v1/districts`, {
        params: {
          region_id: this.form.region_id
        }
      }).then(({data}) => {
        this.districts = data.districts
      }).catch((err) => {
        console.error('quarters fetch error', err)
      })
    },
    getBoards() {
      this.$http.get(`api/v1/boards`,{params:{status:1}}).then(({data}) => {
        this.boards = data.boards
      }).catch((err) => {
        console.error('boards fetch error', err)
      })
    },
  },
  mounted() {
    if (this.$route.params.id) {
      this.resultId = this.$route.params.id;
    }
    if (this.$store.state.user.role === 'moderator') {
      this.form.region_id = this.$store.state.user.region_id
      this.form.district_id = this.$store.state.user.district_id
    } else {
      this.isAdmin = true
      this.getRegions()
    }
    this.getBoards()
  }
}
</script>

<style scoped>
.page-wrap {
  padding: 10px;
}
</style>
